import isString from 'lodash/isString';
import isEmpty from 'lodash/isEmpty';
import toUpper from 'lodash/toUpper';
export class StringUtil {
    static isString(stringOrNumber) {
        return isString(stringOrNumber);
    }
    static isEmpty(value) {
        if (isString(value)) {
            return isEmpty(value);
        }
        else if (value === undefined) {
            return true;
        }
        return false;
    }
    static isNotEmpty(value) {
        return !isEmpty(value);
    }
    static isAllEmpty(values) {
        if (Array.isArray(values)) {
            for (let value of values) {
                if (!isEmpty(value)) {
                    return false;
                }
            }
            return true;
        }
        else if (values === undefined) {
            return true;
        }
        return false;
    }
    /**
     * Whitespaces return empty
     * @param value
     * @returns {boolean}
     */
    static isBlank(value) {
        if (isString(value)) {
            return isEmpty(value.trim());
        }
        return StringUtil.isEmpty(value);
    }
    static isAllBlank(values) {
        if (Array.isArray(values)) {
            for (let value of values) {
                if (!StringUtil.isBlank(value)) {
                    return false;
                }
            }
            return true;
        }
        else if (values === undefined) {
            return true;
        }
        return false;
    }
    static isNoneBlank(values) {
        if (Array.isArray(values)) {
            for (let value of values) {
                if (StringUtil.isBlank(value)) {
                    return false;
                }
            }
            return true;
        }
        return !StringUtil.isBlank(values);
    }
    static toUpper(value) {
        return toUpper(value);
    }
    /**
     * Count multi-bytes characters
     * @param value
     */
    static characterCount(value = '') {
        return Array.from(value).length;
    }
    static subCharacter(value = '', start = 0, length) {
        const chars = Array.from(value);
        return chars.slice(start, start + length).join('');
    }
    static replaceAll(str, find, replace) {
        return str.replace(new RegExp(find, 'g'), replace);
    }
    // https://stackoverflow.com/questions/20486551/javascript-function-to-convert-utf8-string-between-fullwidth-and-halfwidth-forms
    static toHalfWidth(chars) {
        let ascii = '';
        for (let i = 0, l = chars.length; i < l; i++) {
            let c = chars[i].charCodeAt(0);
            // make sure we only convert half-full width char
            if (c >= 0xff00 && c <= 0xffef) {
                // eslint-disable-next-line no-bitwise
                c = 0xff & (c + 0x20);
            }
            else if (c === 0x3002) {
                // for full width dot 。
                c = '.'.charCodeAt(0);
            }
            ascii += String.fromCharCode(c);
        }
        return ascii;
    }
}
